<template>
  <div class="wrap">
    <div
      class="order-list-wrap"
      :style="`grid-template-rows: repeat(${getPageItem / 2}, calc(100% / ${getPageItem / 2}));`"
    >
      <div
        :class="['order-item', selectOrder?.order_id === item.order_id ? 'order-item-selected' : '']"
        v-for="(item, index) in renderList"
        :key="index"
        @click="handleClick(item)"
      >
        <!-- 訂單管理 -->
        <div v-if="type === 'manage'" class="order-content">
          <p style="font-size: 2.2rem">
            {{ item.order_date.slice(0, 16) }}
            {{ item.takeaway_type }}
            <span class="source-tag">{{ item.source }}</span>
            <span v-if="item.status === 16" class="unWriteoff-tag">未沖銷</span>
            <span v-if="item.status === 18" class="void-tag">已作廢</span>
          </p>
          <p>
            序號 {{ item.serial_code.slice(-5) }} / {{ item.invoice_number }}
            {{ item.outside_order_id ? ` / 取餐號 ${item.outside_order_id}` : '' }}
          </p>
          <!-- <div class="unread"></div> -->
        </div>
        <!-- 掛單 / 內部訂單 / 外部平台-->
        <div v-else class="order-content">
          <p style="font-size: 2.2rem; white-space: nowrap">
            <span v-if="type === 'pending'">取餐號 {{ item.outside_order_id }}</span>
            <span v-else-if="type === 'outside'">取餐號 {{ item.outside_order_id }}</span>
            <span v-else>序號 {{ item.serial_no }}</span>
            − {{ item.order_take_time.split(' ')[1] }}
            {{ mapValue[item.take_away_method]?.label }}
            <span class="source-tag">{{ mapValue[item.source]?.label }}</span>
            <span v-for="num in item.delay_accept_count" :key="num" class="delay-tag">延</span>
          </p>
          <p>數量：{{ item.quantity }}，品項：{{ item.products.join('、') }}</p>
        </div>
        <!-- 金額 -->
        <div :class="['amount', item.total.toString().length > 5 ? 'size-22' : '']">
          {{ item.total }}
        </div>
        <!-- <div v-if="type === 'incoming'" class="unread"></div> -->
      </div>
    </div>
    <cus-page :totalPage="totalPage" v-model:currentPage="currentPage"></cus-page>
  </div>
</template>
<script>
import { computed, watch } from 'vue';
import { useGetters } from '@/utils/mapStore';
import { mapValue } from '@/utils/define';
export default {
  name: 'order-list',
  props: ['type', 'orderList', 'selectOrder', 'listPage'],
  emits: ['update:selectOrder', 'update:listPage'],
  setup(props, context) {
    const currentPage = computed({
      get: () => props.listPage,
      set: (val) => context.emit('update:listPage', val),
    });
    //處理分頁品項
    const getPageItem = useGetters('handleOrder', ['getPageItem']);
    const totalPage = computed(() => Math.ceil(props.orderList.length / getPageItem.value) || 1);
    const renderList = computed(() =>
      props.orderList.slice((currentPage.value - 1) * getPageItem.value, currentPage.value * getPageItem.value)
    );
    //換頁時
    watch(currentPage, () => {
      if (props.selectOrder !== null) {
        context.emit('update:selectOrder', null);
      }
    });
    //點擊
    const handleClick = (item) => {
      if (props.selectOrder?.order_id === item.order_id) context.emit('update:selectOrder', null);
      else context.emit('update:selectOrder', item);
    };
    return { mapValue, getPageItem, totalPage, renderList, currentPage, handleClick };
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  display: grid;
  grid-template-rows: auto 70px;
  border: 2px solid $color-gray-10;
  border-radius: 4px;
}
.order-list-wrap {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 50%));
  grid-gap: 1px;
  grid-auto-flow: column;
  .order-item {
    width: 100%;
    outline: 1px solid $color-gray-10;
    padding: 0 20px 0 16px;
    display: grid;
    grid-template-columns: 84% auto;
    align-items: center;
    color: $color-blue;
    position: relative;
    cursor: pointer;
    transition: 0.2s;
    .order-content > p:nth-of-type(2) {
      font-size: 2rem;
      color: $color-gray-50;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      transition: 0.2s;
    }
    @mixin base-tag {
      display: inline-block;
      font-size: 1.6rem;
      color: #fff;
      border-radius: 4px;
      padding: 0 5px;
      margin-right: 1.5px;
      line-height: 2.6rem;
      transform: translateY(-2px);
    }
    .source-tag {
      @include base-tag;
      background-color: $color-blue;
      margin-left: 3px;
      margin-right: 3px;
    }
    .delay-tag {
      @include base-tag;
      background-color: $color-red;
      border-radius: 50%;
      padding: 0 4px;
      font-size: 1.5rem;
      line-height: 2.5rem;
    }
    .void-tag {
      @include base-tag;
      background-color: $color-gray-30;
    }
    .unWriteoff-tag {
      @include base-tag;
      background-color: $color-red;
    }
    .amount {
      font-size: 2.6rem;
      text-align: right;
    }
    .size-22 {
      font-size: 2.2rem;
    }
    .unread {
      position: absolute;
      top: 8%;
      right: 1%;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: $color-yellow;
    }
    &-selected {
      background-color: $color-green;
      color: #fff;
      .order-content > p:nth-of-type(2) {
        color: #fff;
      }
    }
  }
}
</style>
